import React from "react";
import PropTypes from "prop-types";
import browser from "web/script/utils/browser";
import { ProductImagePropType } from "web/types/product.js";
import styles from "./product-gallery-image.css";


function NormalImage({ image, onClick }) {
    return (
        <div className={styles.normalImageWrapper} onClick={onClick}>
            <img
                className={styles.normalImage}
                alt={image.altText}
                src={browser.retina ? image.large_url_2x : image.large_url}
            />
        </div>
    );
}

NormalImage.propTypes = {
    image: ProductImagePropType,
    onClick: PropTypes.func,
};

function FullScreenImage({ image }) {
    return (
        <div className={styles.fullscreenImageWrapper}>
            <img alt={image.altText} src={browser.retina ? image.large_url_2x : image.large_url} />
        </div>
    );
}

FullScreenImage.propTypes = {
    image: ProductImagePropType,
};

function Image({ isFullscreen, onClick, image }) {
    if (isFullscreen) {
        return <FullScreenImage image={image} />;
    }
    return <NormalImage image={image} onClick={onClick} />;
}

export default Image;

Image.propTypes = {
    isFullscreen: PropTypes.bool,
    image: ProductImagePropType,
    onClick: PropTypes.func,
};

Image.defaultProps = {
    isFullscreen: false,
};
